export const Welcome = () => {

  $('.button-connect').click(() => {
    window.open('https://x5paket.ru/fastbuy?bundle=standard199', '_blank')
  })
  
  $('.enter-account').on('click', () => {
    ym(94994504,'reachGoal','onboarding-quiz', {onboarding: 'lk'})
    window.open('https://x5paket.ru/', '_blank')
  })

  $('.go-to-pyaterochka').on('click', () => {
    window.open('https://5ka.onelink.me/PnJ3/1yeifv78', '_blank')
  })
  $('.go-to-perekrestok').on('click', () => {
    window.open('https://app.perekrestok.ru/2MFR/jmr03wz0', '_blank')
  })

  $('.five-free-pyat-card').click(() => {
    $('.five-free-pyat-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.three-free-perek-card').click(() => {
    $('.three-free-perek-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.tea-cashback-card').click(() => {
    $('.tea-cashback-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.food-cashback-card').click(() => {
    $('.food-cashback-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.bake-cashback-card').click(() => {
    $('.bake-cashback-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.five-percent-cashback-card').click(() => {
    $('.five-percent-cashback-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.ten-favourite-card').click(() => {
    $('.ten-favourite-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.to-hundred-percent-card').click(() => {
    $('.to-hundred-percent-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-light-blue');
  })

  $('.sokolov-card').click(() => {
    $('.sokolov-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-violet');
  })

  $('.litres-card').click(() => {
    $('.litres-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-orange');
  })

  $('.inviro-card').click(() => {
    $('.inviro-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-aquamarine');
  })

  $('.o-t-trip-card').click(() => {
    $('.o-t-trip-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-yellow');
  })

  $('.read-card').click(() => {
    $('.read-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-blue');
  })

  $('.kari-card').click(() => {
    $('.kari-modal').show();
    $('.sheet-wrapper').addClass('show-modal');
    $('.sheet-content').addClass('bg-sky-blue');
  })
  
  $('.close-line, .backdrop').click(() => {
    console.log("close");
    
    $('.five-free-pyat-modal').hide();
    $('.three-free-perek-modal').hide();
    $('.tea-cashback-modal').hide();
    $('.food-cashback-modal').hide();
    $('.bake-cashback-modal').hide();
    $('.five-percent-cashback-modal').hide();
    $('.ten-favourite-modal').hide();
    $('.to-hundred-percent-modal').hide();
    $('.sokolov-modal').hide();
    $('.litres-modal').hide();
    $('.inviro-modal').hide();
    $('.o-t-trip-modal').hide();
    $('.read-modal').hide();
    $('.kari-modal').hide();

    $('.sheet-wrapper').removeClass('show-modal');

    $('.sheet-content').removeClass('bg-light-blue');
    $('.sheet-content').removeClass('bg-violet');
    $('.sheet-content').removeClass('bg-orange');
    $('.sheet-content').removeClass('bg-aquamarine');
    $('.sheet-content').removeClass('bg-yellow');
    $('.sheet-content').removeClass('bg-blue');
    $('.sheet-content').removeClass('bg-sky-blue');
  })

}
